import { TrackShipment } from "~/features/track-shipment/track-shipment.tsx";

export function TrackShipmentPage() {
	return <TrackShipment />;
}
